'use client';

import { CommonImage, Trackable } from '@/components/common';
import { CarouselItem } from '@/components/ui/carousel';
import Link from 'next/link';

interface TProps {
  _id: string;
  name: string;
  eventCode: string;
  poster: Array<{
    url: string;
  }>;
}

const SliderCarouselItem = ({ _id, name, eventCode, poster }: TProps) => {
  return (
    <CarouselItem key={_id} className='basis-full sm:basis-auto'>
      <Trackable
        eventName='Click'
        eventScope='Event (Hero Slider)'
        eventProps={{
          'Event Name': name,
          'Event Code': eventCode,
        }}
        className='h-full w-full'
      >
        <Link href={`/${eventCode}`} className='h-full w-full'>
          <CommonImage
            src={poster[0]?.url}
            alt={eventCode}
            width={200}
            height={100}
            className='aspect-[18/10] h-full w-full overflow-hidden sm:rounded-md md:aspect-[25/12] md:rounded-2xl'
            sizes='(max-width: 640px) 200px,(max-width: 1024px) 300px, 600px'
          />
        </Link>
      </Trackable>
    </CarouselItem>
  );
};

export default SliderCarouselItem;
